import Vue from 'vue'
import { api } from '#/Api.js'
import axios from '#/plugins/Axios.js'

const state = {
    avatar: '',
    email: '',
    name: '',
    user: {}
}

const getters = {
    avatar: state => state.avatar,
    email: state => state.email,
    name: state => state.name,
    user: state => state.user
}

const actions = {
    setUser(context, user) {
        const u = {
            name: user.getName(),
            email: user.getEmail(),
            avatar: user.getImageUrl()
        }
        const defaultAxiosBaseURL = axios.defaults.baseURL
        axios.defaults.baseURL = '/'
        axios.post('auth/check-user', u)
        //axios.post(api.path('checkUser'), u)
            .then(response => {

                /*axios.get('api/user')
                    .then(response => {
                        console.log(response)
                    })
                    .catch(error => {
                        console.log('Second level error')
                        console.log(error)
                    })*/

                context.commit('SET_AVATAR', u.avatar)
                context.commit('SET_EMAIL', u.email)
                context.commit('SET_NAME', u.name)
                context.dispatch('storeUser', u)
            })
            .catch(error => {
                console.log('First level error')
                console.log(error)
            })
            .finally(() => {
                axios.defaults.baseURL = defaultAxiosBaseURL
            })
    },
    storeUser(context, user) {
        context.commit('SET_USER', user)
        Vue.$cookies.set('user', user)
    }
}

const mutations = {
    SET_AVATAR(state, value) {
        state.avatar = value
    },
    SET_EMAIL(state, value) {
        state.email = value
    },
    SET_NAME(state, value) {
        state.name = value
    },
    SET_USER(state, value) {
        state.user = value
    },
}

export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
}